import { render, staticRenderFns } from "./RoleModule.vue?vue&type=template&id=86e64f3e&scoped=true&"
import script from "./RoleModule.vue?vue&type=script&lang=js&"
export * from "./RoleModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e64f3e",
  null
  
)

export default component.exports